import { Component, Input } from '@angular/core';
import { Rodeo } from '../../../../../model/rodeo';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { BackNumberConfig } from '../../../../../model/back-number-config';

@Component({
    selector: 'staff-backnumber-config',
    templateUrl: 'backnumber-config.component.html'
})
export class BackNumberConfigSection {
    @Input() rodeo: Rodeo;
    @Input() disciplines: string[];

    constructor() {

    }

    matchEventTypes(a: string, b: string) {
        return a == b;
    }

    addNewConfig() {
        if (!this.rodeo.backNumberConfigs)
            this.rodeo.backNumberConfigs = [];

        this.rodeo.backNumberConfigs.push(new BackNumberConfig());
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/backnumbers/backnumber-config.component.ts